import { Link, Divider } from '@heroui/react'

export const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="mt-auto">
      <Divider />
      <div className="container mx-auto px-4 py-6">
        {/* Mobile: Compact vertical layout */}
        <div className="flex flex-col items-center space-y-4 md:hidden">
          {/* Links */}
          <div className="flex flex-wrap items-center justify-center gap-6 text-sm">
            <Link
              href="/about"
              color="foreground"
              className="hover:text-primary transition-colors"
            >
              About
            </Link>
            <Link
              href="/privacy"
              color="foreground"
              className="hover:text-primary transition-colors"
            >
              Privacy Policy
            </Link>
            {/* TODO: Uncomment when Terms of Use is ready */}
            {/* <Link
              href="/terms"
              color="foreground"
              className="hover:text-primary transition-colors"
            >
              Terms of Service
            </Link> */}
            <Link
              href="/contact"
              color="foreground"
              className="hover:text-primary transition-colors"
            >
              Contact
            </Link>
          </div>

          {/* Copyright */}
          <div className="text-xs text-default-500 text-center">
            © {currentYear} Cyrano. All rights reserved.
          </div>
        </div>

        {/* Desktop: Horizontal layout with copyright left, links right */}
        <div className="hidden md:flex items-center justify-between">
          {/* Copyright - Left */}
          <div className="text-xs text-default-500">
            © {currentYear} Cyrano. All rights reserved.
          </div>

          {/* Links - Right */}
          <div className="flex items-center gap-6 text-sm">
            <Link
              href="/about"
              color="foreground"
              className="hover:text-primary transition-colors"
            >
              About
            </Link>
            <Link
              href="/privacy"
              color="foreground"
              className="hover:text-primary transition-colors"
            >
              Privacy Policy
            </Link>
            {/* TODO: Uncomment when Terms of Use is ready */}
            {/* <Link
              href="/terms"
              color="foreground"
              className="hover:text-primary transition-colors"
            >
              Terms of Use
            </Link> */}
          </div>
        </div>
      </div>
    </footer>
  )
}
